import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface PageLoaderProps {
  message?: string;
  fullScreen?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({ 
  message = 'Yükleniyor...', 
  fullScreen = false 
}) => {
  return (
    <div className={`flex items-center justify-center ${fullScreen ? 'min-h-screen' : 'min-h-[50vh]'}`}>
      <div className="text-center">
        <LoadingSpinner size="md" className="mx-auto" />
        <p className="mt-4 text-primary-charcoal/80">{message}</p>
      </div>
    </div>
  );
};

export default PageLoader; 